<template>
  <v-list-item
    :to="`${$route.params.project?'/projects/'+$route.params.project:'library'}/view/${type}/${object[_.find($appConfig.objects,{type:type}).identifier]}`"
    @click="dialog++"
  >
    <v-list-item-avatar>
      <v-icon>{{ _.find($appConfig.objects,{type:type}).icon }}</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <!-- <object-dialog
        :id="object.id"
        dialog-only
        :activator="dialog"
        :type="type"
        :name="object.name"
        @close="dialog=0"
        @delete="$emit('delete')"
        @update="$emit('update')"
      /> -->
      <v-list-item-title
        v-text="object.name"
      />
      <v-list-item-subtitle
        v-if="object.description"
        class="mt-2"
        v-text="object.description"
      />
    </v-list-item-content>
    <v-spacer />
    <v-list-item-action>
      <span v-if="object.visualizations">
        <v-icon color="grey lighten-1">
          mdi-cube-scan
        </v-icon>
        {{ object.visualizations.length }} Visualizations
      </span>
      <span v-if="object.widgets_count">
        <v-icon color="grey lighten-1">
          mdi-view-dashboard-outline
        </v-icon>
        {{ object.widgets_count }} Widgets
      </span>
      <span v-if="object.nb_users">
        <v-icon color="grey lighten-1">
          mdi-account-group
        </v-icon>
        {{ object.nb_users }} Users
      </span>
      <span v-if="object.nb_calls">
        <v-icon color="grey lighten-1">
          mdi-flash
        </v-icon>
        {{ object.nb_calls }} Calls
      </span>
      <span v-if="object.nb_lines">
        <v-icon color="grey lighten-1">
          mdi-text-subject
        </v-icon>
        {{ object.nb_lines }} Lines
      </span>
    </v-list-item-action>
    <v-list-item-action v-if="clonable">
      <span>
        <v-menu
          bottom
          left
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              @click.stop
              @click.prevent
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item-group>
              <v-list-item @click="$emit('clone')">
                <v-list-item-icon>
                  <v-icon>mdi-content-duplicate</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Clone</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </span>
    </v-list-item-action>
  </v-list-item>
</template>
<script>
  export default {
    components: {
    },
    props: {
      object: {
        type: Object,
        required: true,
      },
      type: {
        type: String,
        required: true,
        default: '',
      },
      clonable: {
        type: Boolean,
        required: false,
        default: false,
      },
      deletable: {
        type: Boolean,
        required: false,
        default: false,
      },
      to: {
        type: String,
        required: false,
        default: '',
      },
    },
    data () {
      return {
        dialog: 0,
      }
    },
  }
</script>
